import Splide from '@splidejs/splide';
import { Translations } from '../utils';
import './obbligazioni-slider.scss';

export class ObbligazioniSliderEsg {
  constructor() {
    this.el = document.querySelector('.js-obbligazioni-slider-esg');
    if (!this.el) return;

    this.init();
  }

  init() {
    const splide = new Splide(this.el, {
      type: 'slide',
      arrows: true,
      pagination: false,
      gap: '24px',
      perPage: 3,
      focus: 0,
      destroy: false,
      drag: true,
      breakpoints: {
        992: {
          perPage: 2.2,
        },
        767: {
          perPage: 1.2,
        },
      },
      i18n: Translations.getSplideI18n(),
    });

    const checkVisibility = () => {
      const { perPage } = splide.options;
      const totalSlides = splide.length;
      const arrows = this.el.querySelector('.splide__arrows');

      if (arrows) {
        if (totalSlides <= perPage) {
          arrows.style.display = 'none'; // Nasconde se non servono
        } else {
          arrows.style.display = ''; // Ripristina se servono
        }
      }
    };

    splide.on('mounted updated', checkVisibility);
    splide.mount();

    const next = this.el.querySelector('.splide__arrow--next');
    const updateArrows = () => {
      if (!window.matchMedia('(min-width: 992px)').matches) return;
      const { index } = splide;
      const last = splide.length - Math.floor(splide.options.perPage);

      // Se sono all’ultima slide disabilito next
      if (index >= last) {
        next.classList.add('is-disabled');
      } else {
        next.classList.remove('is-disabled');
      }
    };

    // primo chek al caricamento
    updateArrows();
    splide.on('mounted move updated', updateArrows);
  }
}
